module.exports = __webpack_public_path__ + "static/media/pointBadgeLevel1Locked.120713d9.png";